import React, { useEffect, useState } from 'react';
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';
import store from 'store';
import useStyles from '../../styles/style';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction } from '../../redux/actions/userAction';
import AlertMessage from '../helpers/AlertMessage';
import { decodeToken } from '../../utils';
import i18next from 'i18next';

const handleDisable = (props, login) => {
  return !props.values.emailOrPhone ||
    !props.values.password ||
    login.loading ||
    Object.keys(props.errors).length !== 0
    ? true
    : false;
};

const Login = ({ defaultEmailVal }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState({});

  const login = useSelector((state) => state.login);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const loginSchema = yup.object({
    emailOrPhone: yup.string().required(),
  });

  const handleSubmit = (values) => {
    dispatch(loginAction(values));
  };

  useEffect(() => {
    if (login.status === 200) {
      store.set('token', login.data.token);
      i18next.changeLanguage(decodeToken().preferredLanguage);
    }
    if (
      decodeToken() &&
      decodeToken().applicant !== null &&
      decodeToken().userRole?.RoleName === 'Applicant'
    ) {
      window.location.href = '/my/application';
    }
    if (
      decodeToken() &&
      (decodeToken().userRole?.RoleName === 'Back-End Officer' ||
        decodeToken().userRole?.RoleName === 'Admin')
    ) {
      window.location.href = '/loan/applications';
    }
    if (decodeToken() && decodeToken().userRole?.RoleName === 'Bank Officer') {
      window.location.href = '/bank';
    }
    if (decodeToken() && decodeToken().isSuperAdmin) {
      window.location.href = '/users';
    }
    if (
      decodeToken() &&
      decodeToken().applicant === null &&
      decodeToken().userRole?.RoleName === 'Applicant'
    ) {
      window.location.href = '/application';
    }
  }, [login.status, login?.data?.token]);

  return (
    <div>
      {login.error && <AlertMessage severity='error' message={login.error} />}
      <Typography variant='h6' className={classes.authText}>
        {t('login-title')}
      </Typography>
      <Formik
        validationSchema={loginSchema}
        initialValues={{ emailOrPhone: defaultEmailVal || '', password: '' }}
        onSubmit={(values) => handleSubmit(values)}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              size='small'
              id='email'
              label={<span className={classes.authText}>Email or Phone</span>}
              name='emailOrPhone'
              onChange={props.handleChange('emailOrPhone')}
              value={props.values.emailOrPhone}
              error={
                props.values.emailOrPhone !== '' &&
                Object.prototype.hasOwnProperty.call(
                  props.errors,
                  'emailOrPhone'
                )
              }
              helperText={
                props.values.emailOrPhone !== '' && props.errors.emailOrPhone
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <AccountCircleIcon />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              variant='outlined'
              type={showPassword ? 'password' : 'text'}
              margin='normal'
              fullWidth
              size='small'
              id='password'
              label={<span className={classes.authText}>{t('password')}</span>}
              name='password'
              onChange={props.handleChange('password')}
              value={props.values.password}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? (
                        <Tooltip title={t('show-password')}>
                          <Visibility />
                        </Tooltip>
                      ) : (
                        <Tooltip title={t('hide-password')}>
                          <VisibilityOff />
                        </Tooltip>
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography>
              <Link to='/find-account' className={classes.forgetLink}>
                {t('forget-password')}
              </Link>
            </Typography>
            <Button
              type='submit'
              variant='contained'
              disabled={handleDisable(props, login)}
              className={classes.submit}
            >
              {login.loading ? (
                <>
                  <CircularProgress size={20} />
                  &nbsp;
                  {t('loading')}
                </>
              ) : (
                t('login')
              )}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Login;
